// extracted by mini-css-extract-plugin
export var overlay = "dialog-module--overlay--DjWKY";
export var content = "dialog-module--content--2zYfy";
export var description = "dialog-module--description--3etA6";
export var buttons = "dialog-module--buttons--13av4";
export var closeButton = "dialog-module--closeButton--1Pg13";